import React, { Suspense } from "react";
import "../styles/index.css";
import "../styles/components.css";
import { useLocales } from "../core/i18n";
import { SiteSettingsProvider } from "../core/site";
import { AdminProvider } from "../features/admin";
import { ErrorBoundary } from "../ui/kit";
import { ScrollProgress, ScrollToTop } from "../ui/shell";
import { AppRoutes } from "./routes";
import { usePageViews } from "./usePageViews";

/** What a visitor sees while a lazy page chunk downloads. */
function RouteFallback() {
	const { t } = useLocales();
	return (
		<div
			className="min-h-screen bg-pp-bg flex items-center justify-center"
			role="status"
			aria-live="polite"
		>
			<p className="font-mono text-xs text-pp-muted uppercase tracking-pp-eyebrow animate-pulse">
				{t("ui.loading")}
			</p>
		</div>
	);
}

/**
 * The application: admin and site-settings providers, scroll chrome,
 * analytics page views, and the route table behind an error boundary and a
 * loading fallback. Expects a Router above it.
 */
function App() {
	usePageViews();

	return (
		<AdminProvider>
			<SiteSettingsProvider>
				<div className="App w-full mx-auto">
					<ScrollProgress />
					<ScrollToTop />
					<ErrorBoundary>
						<Suspense fallback={<RouteFallback />}>
							<AppRoutes />
						</Suspense>
					</ErrorBoundary>
				</div>
			</SiteSettingsProvider>
		</AdminProvider>
	);
}

export default App;
